import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "upload-image-box" }
const _hoisted_2 = { class: "upload-box" }
const _hoisted_3 = { class: "add-image" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-camera-retro" })
], -1)
const _hoisted_5 = { class: "uploaded-image-area" }
const _hoisted_6 = { class: "upload-plus-btn mb-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus-circle" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "uploaded-images mb-6"
}
const _hoisted_9 = { class: "image-box" }
const _hoisted_10 = { class: "image-heading" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_12 = { class: "cover-image-text" }
const _hoisted_13 = {
  key: 1,
  class: "uploaded-images mb-6"
}
const _hoisted_14 = { class: "image-box" }
const _hoisted_15 = { class: "image-heading" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("  ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode(_component_el_col, {
      span: 24,
      class: "upload-image-col"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _withDirectives(_createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("input", {
                type: "file",
                class: "upload-btn",
                accept: "image/png, image/jpg, image/jpeg",
                multiple: "",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageChange && _ctx.onImageChange(...args)))
              }, null, 32),
              _hoisted_4,
              _createVNode("strong", null, _toDisplayString(_ctx.$t("message.UPLOAD_IMAGES")), 1),
              _createVNode("span", null, "JPG, GIF " + _toDisplayString(_ctx.$t("message.OR")) + " PNG " + _toDisplayString(_ctx.$t("message.FORMAT")), 1)
            ])
          ], 512), [
            [_vShow, _ctx.previewImage.length == 0 && !_ctx.readOnly]
          ]),
          _withDirectives(_createVNode("div", _hoisted_5, [
            (!_ctx.readOnly)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 5,
                  id: "add-image"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("input", {
                        type: "file",
                        class: "upload-btn",
                        accept: "image/png, image/jpg, image/jpeg",
                        multiple: "",
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImageChange && _ctx.onImageChange(...args)))
                      }, null, 32),
                      _hoisted_7
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewImage, (img, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                span: 5,
                offset: index == 3 ? 0 : 1,
                key: index
              }, {
                default: _withCtx(() => [
                  (index == 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        _createVNode("div", _hoisted_9, [
                          _createVNode("img", {
                            src: img.src,
                            alt: "uploaded Images"
                          }, null, 8, ["src"]),
                          _createVNode("span", _hoisted_10, [
                            _createVNode("i", {
                              class: "fas fa-search",
                              onClick: ($event: any) => (_ctx.showMedia(index))
                            }, null, 8, ["onClick"]),
                            _hoisted_11,
                            (!_ctx.readOnly)
                              ? (_openBlock(), _createBlock("i", {
                                  key: 0,
                                  class: "fas fa-trash-alt",
                                  onClick: ($event: any) => (_ctx.removeImage(index, img.id))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("message.COVER")) + " " + _toDisplayString(_ctx.$t("message.IMAGE")), 1)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("span", _hoisted_15, [
                            _createVNode("i", {
                              class: "fas fa-search",
                              onClick: ($event: any) => (_ctx.showMedia(index))
                            }, null, 8, ["onClick"]),
                            _hoisted_16,
                            (!_ctx.readOnly)
                              ? (_openBlock(), _createBlock("i", {
                                  key: 0,
                                  class: "fas fa-trash-alt",
                                  onClick: ($event: any) => (_ctx.removeImage(index, img.id))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          (_openBlock(), _createBlock("img", {
                            src: img.src,
                            key: index,
                            alt: "uploaded Images"
                          }, null, 8, ["src"]))
                        ])
                      ]))
                ]),
                _: 2
              }, 1032, ["offset"]))
            }), 128))
          ], 512), [
            [_vShow, _ctx.previewImage.length != 0]
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Image)
  ], 64))
}